module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"generateApiKeyButton.generateText":"Generate","generateApiKeyButton.error":"There was an issue generating an api key."}}')
  delete Component.options._Ctor
}
